import Chart from 'chartjs';
import i18n from 'l10n';
import ch from 'libs/chart-helpers';
import Handlebars from 'handlebars';
import ReportsMessageChartSimpleView from 'js/views/reports-message-chart-simpleview';


class TriggerReportChartSimpleview extends ReportsMessageChartSimpleView{

    options = {
        from: null, //moment
        to: null, //moment
        window: null,
        fromAll: null,
        toAll: null,
        unitAll: null,
        queryOptions: {
            from: null, //long millis
            to: null, //long millis
            unit: null,
            window: null,
            dow: null //first day of week (0-Sunday ...)
        }
    };

    constructor(campaignId, pingUrl) {
        super();
        this.campaignId = campaignId;
        this.pingUrl = pingUrl;
    }

    async refresh() {
        try {
            const pingResponse = await $.ajaxDefaultQ({
                url: '/CampaignCloud/RememberMeController/ping',
                type: 'GET',
                dataType: "json"
            });

            if (pingResponse.status !== 'success') {
                throw Error(pingResponse.status);
            }

        } catch (e) {
            console.error(e);
            window.open('Login.htm', '_self');
        }

        console.log(`Going to ${this.options.from.format('ll')}(${this.options.queryOptions.from}) - ${this.options.to.format('ll')}(${this.options.queryOptions.to}) window=${this.options.window} unit=${this.options.queryOptions.unit} dow=${this.options.queryOptions.dow}`);

        try {
            const resp = await $.ajaxDefaultQ({
                url: `/CampaignCloud/Report/TriggerMessageChart/${this.campaignId}`,
                type: 'POST',
                data: JSON.stringify(this.options.queryOptions),
                contentType: 'application/json',
                dataType: 'json'
            });

            var isSMS = resp.type === "SMS";
            if (resp.unit) {
                $(this.selector).find('#messageChartXAxisLabel').text(i18n.t(`reports.label-${resp.unit}`));
            }

            //array.reduce((a,b) => a+b) sums all elements of
            // an array, one by one  <==== ES6, not supported before Chrome 41.
            // Use array.reduce(function(a,b){ return a+b; }) instead
            var reduceFunc = function (a, b) {
                return a + b;
            };

            var messagesLength;
            var datasets;
            if (isSMS) {
                var sms = resp.sms.reduce(reduceFunc);
                $(this.selector).find("#sms-sent-count_1-last-week").show().text(sms);
                var cl = Handlebars.helpers.dynamicFontSize(sms, $(this.selector).find("#sms-sent-count_1-last-week").data("font-length"));
                $(this.selector).find("#sms-sent-count_1-last-week").addClass(cl.toString());

                messagesLength = resp.sms.length;

                datasets = [
                    {
                        label: i18n.t('reports.smslabel'),
                        fillColor: ch.colors.mauveUno.transparent,
                        strokeColor: ch.colors.mauveUno.solid,
                        pointColor: ch.colors.mauveUno.solid,
                        pointStrokeColor: "#fff",
                        pointHighlightFill: "#fff",
                        pointHighlightStroke: ch.colors.mauveUno.solid,
                        data: resp.sms
                    },
                    {
                        label: i18n.t('reports.smsundellabel'),
                        fillColor: ch.colors.blueDue.transparent,
                        strokeColor: ch.colors.blueDue.solid,
                        pointColor: ch.colors.blueDue.solid,
                        pointStrokeColor: "#fff",
                        pointHighlightFill: "#fff",
                        pointHighlightStroke: ch.colors.blueDue.solid,
                        data: resp.smsUndelivered
                    }
                ];
            } else {
                // var email = resp.email.reduce(reduceFunc);
                messagesLength = resp.email.length;

                datasets = [
                    {
                        label: i18n.t('reports.emaillabel'),
                        fillColor: ch.colors.greenTre.transparent,
                        strokeColor: ch.colors.greenTre.solid,
                        pointColor: ch.colors.greenTre.solid,
                        pointStrokeColor: "#fff",
                        pointHighlightFill: "#fff",
                        pointHighlightStroke: ch.colors.greenTre.solid,
                        data: resp.email
                    },
                    {
                        label: i18n.t('reports.emailUndelLabel'),
                        fillColor: ch.colors.orangeCinque.transparent,
                        strokeColor: ch.colors.orangeCinque.solid,
                        pointColor: ch.colors.orangeCinque.solid,
                        pointStrokeColor: "#fff",
                        pointHighlightFill: "#fff",
                        pointHighlightStroke: ch.colors.orangeCinque.solid,
                        data: resp.emailUndelivered
                    }
                ];
            }

            if (this.messageChart) {
                this.messageChart.destroy();
            }
            var labels = i18n.labels(this.options.from, this.options.window, this.options.queryOptions.unit, messagesLength);

            var data = {
                labels: labels,
                datasets: datasets
            };

            var options = {
                responsive: true,
                legendTemplate: "<% %><div style=\"text-align:center;\"><% for (var i=0; i<datasets.length; i++){%><span style=\"margin:0 10px 0 10px;text-align:center\"><span style=\"background-color:<%=datasets[i].strokeColor%>; width:15px; height:10px; display:inline-block\"></span><%if(datasets[i].label){%> <span style=\"font-size:7pt;\" class=\"text-bold\"><%=datasets[i].label%><%}%></span</span><%}%></div><% %>"
            };
            var canvas = $(this.selector).find('#messageChart').get(0);
            var ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            this.messageChart = new Chart(ctx).Bar(data, options);
            var legend = this.messageChart.generateLegend();
            $(this.selector).find('#messageChartLabels').html(legend).find('.export-button').click(() => ch.exportHandler(this.messageChart));
            $(this.selector).find('#messageChart').unbind("click").bind("click", evt => {
                if (this.options.window !== "day") {
                    var ord = ch.getOrdinalPositionOfEvent(this.messageChart, evt);
                    if (ord === -1) {
                        return;
                    }
                    console.log(`X=${ord}`);
                    this.setWindow(this.goSmaller(this.options.window));
                    $(this.selector).find(".timegranule-buttons").find("[data-timegranule]").removeClass('active');
                    $(this.selector).find(".timegranule-buttons").find(`[data-timegranule='${this.options.window}']`).addClass('active');
                    this.options.from.add(ord, `${this.options.window}s`);
                    this.setWindow(this.options.window);
                    this.refresh();
                }
            });

        } catch (e) {
            console.error(e);
        }
    }
}

export default TriggerReportChartSimpleview;
